import { useViewerHasAtLeastCustomerSupportRights } from "@/lib/rights/use-viewer-has-right";
import { isReturnRequestApproved } from "@/pages/(app)/returns/utils/is-return-request-approved";
import { useCurrentReturnRequest } from "@/pages/(app)/returns/utils/current-return-request-context";
import useGenerateLabel from "@babackapp/private-api-client/client/use-generate-label";
import useTranslation from "@babackapp/translations/use-translation";
import { PrinterIcon } from "lucide-react";

export function useRegenerateAction() {
  const t = useTranslation();
  const hasCustomerRight = useViewerHasAtLeastCustomerSupportRights();
  const returnRequest = useCurrentReturnRequest();
  const approvedAlready = isReturnRequestApproved(returnRequest.status);
  const hasBeenTreatedByMerchant = returnRequest.status.treatedMerchant.done;
  const isCancelled = returnRequest.status.cancelled.done;

  const { mutate, isPending } = useGenerateLabel({});

  return {
    label: t("returnDetail.regenerate"),
    icon: <PrinterIcon className="h-5 w-5 text-gray-400" />,
    enabled:
      hasCustomerRight &&
      !hasBeenTreatedByMerchant &&
      !isCancelled &&
      approvedAlready &&
      !isPending,
    onClick: () => {
      mutate({
        returnRequestId: returnRequest.id,
        shopId: returnRequest.shopId,
      });
    },
  };
}
